export const getAuthToken = (state) => state.auth.token;

export const isUserLoggedIn = (state) => {
    return !!getAuthToken(state);
};
